import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Our components
import { TertiaryButton } from 'components/Button/Button';

// Our Routes
import { LOAN_INQUIRY_ROUTE } from 'routes';

function NoLoanTasksOverlay() {
	const navigate = useNavigate();
	return (
		<Box
			sx={{
				position: 'relative',
				zIndex: 1,
				height: '100%',
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'space-evenly',
					height: '100%'
				}}
			>
				<Typography variant="body1">
					There are no loans in progress for your clients. Click below
					<br /> to price a loan for a client.
				</Typography>

				<TertiaryButton onClick={() => navigate(LOAN_INQUIRY_ROUTE)}>
					Price Loan
				</TertiaryButton>
			</Box>
		</Box>
	);
}

export default NoLoanTasksOverlay;
